import { Route } from '@angular/router';
import { Layout } from './components/layout/layout';
import { authGuard } from './guards/auth-guard';
import { guestGuard } from './guards/guest-guard';
import { roleGuard } from './guards/role-guard';

export const appRoutes: Route[] = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./components/login/login').then((m) => m.Login),
  },
  {
    path: 'forgot-password',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./components/login/forgot-password').then(
        (m) => m.ForgotPassword,
      ),
  },
  {
    path: '',
    component: Layout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'registrations',
        loadComponent: () =>
          import('./components/registrations/registrations').then(
            (m) => m.Registrations,
          ),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard').then((m) => m.Dashboard),
        canActivateChild: [roleGuard],
      },
      {
        path: 'participants',
        loadComponent: () =>
          import('./components/participants/participants').then(
            (m) => m.Participants,
          ),
      },
    ],
  },
];
